<template>
  <ts-popover class="ts-dropdown" placement="bottom" :width="popoverWidth || width" trigger="manual" :value="open">
    <ts-button
      slot="reference"
      ref="reference"
      class="ts-dropdown-button"
      :style="{ width: `${width}px` }"
      :class="{ active: open }"
      :size="size"
      :disabled="disabled"
      @click="handleButtonClick"
    >
    <div class="" style="display: flex; align-items:center;">
      <slot name="icon"></slot>
      <span class="text-content">{{ placeholder }}</span>
    </div>
      <ChevronDown />
    </ts-button>
    <template #header>
      <slot name="header"></slot>
    </template>
    <div :style="{ 'max-height': '300px', overflow: 'auto' }">
      <slot></slot>
    </div>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </ts-popover>
</template>

<style lang="scss" scoped>
.ts-dropdown::v-deep {
  .ts-button {
    text-align: left;
    display: flex;

    > span {
      flex-grow: 1;
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      overflow: hidden;
    }

    &:focus,
    &.active {
      border: solid 2px #99ffd1;
    }
  }

  .text-content {
    display: inline-block;
    width: 100%;
  }

  .active .ts-button {
    border: solid 2px #99ffd1;
    box-shadow: -16px -16px 32px 0 #fafbff, 16px 16px 32px 0 #a6abbd;
  }
}
</style>

<script>
import ChevronDown from '../../assets/chevron-down.svg';

export default {
  name: 'TsDropdown',
  components: {
    ChevronDown
  },
  props: {
    size: {
      type: String,
      default: 'small'
    },
    width: {
      type: Number,
      default: 100
    },
    popoverWidth: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: null
    },
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleButtonClick() {
      this.$emit('click');
    },
    handleDocumentClick(event) {
      if (this.open && !this.$refs.reference.$el.contains(event.target)) {
        this.$emit('close');
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.handleDocumentClick);
  }
};
</script>
